module.exports = __webpack_public_path__ + "static/media/referral-white.48b707dc.svg";